// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"566":"9f10ab1c","609":"0ddc83b9","990":"2d93b624"}[chunkId] + ".chunk.js";
};